export default "__VITE_ASSET__DxAGPGkt__"